import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './shared/auth/auth.guard';
import { EmpLoginComponent } from './login/emp-login.component';
import { VendorLoginComponent } from './vendor-login/vendor-login.component';
import { RfpDetailsLinkComponent } from './rfp-details-link/rfp-details-link.component';
import { ForgotPasswordComponent } from './login/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './login/reset-password/reset-password.component';
import { GuestuserComponent } from './login/guestuser/guestuser.component';
import { VendorforgotpasswordComponent } from './vendorforgotpassword/vendorforgotpassword.component';
import { VendorresetpaswordComponent } from './vendorresetpasword/vendorresetpasword.component';
import { VendorverifyotpComponent } from './vendorverifyotp/vendorverifyotp.component';
import { UnableloginvendorComponent } from './unableloginvendor/unableloginvendor.component';
import { QuestionariseComponent } from './questionarise/questionarise.component';
import { GroupchatComponent } from './shared/group-chat/groupchat/groupchat.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: EmpLoginComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'vendor-login', component: VendorLoginComponent },
  { path: 'rfp-link/:id/:name', component: RfpDetailsLinkComponent },
  { path: 'guest-user', component: GuestuserComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'vendor-forgot-password', component: VendorforgotpasswordComponent },
  { path: 'vendor-verify-otp', component: VendorverifyotpComponent },
  { path: 'vendor-reset-password', component: VendorresetpaswordComponent },
  { path: 'unableloginvendor', component: UnableloginvendorComponent },
  { path: 'questionarise', component: QuestionariseComponent },

  { path: 'group-chat', component: GroupchatComponent },



  {
    path: 'login/guestuser',
    loadChildren: () => import('./login/guestuser/guestuser.module').then(m => m.GuestuserModule)
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () => import('./core-module/core.module').then(m => m.CoreModule)
  },

  {
    path: 'vendor-panel',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./vendor-panel/contract/contract.module').then((m) => m.ContractModule)
  },

  {
    path: 'negotiationpanel',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./vendor-panel/negotiation/negotiation.module').then((m) => m.NegotiationModule)
  },

  {
    path: 'master',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./master/master.module').then((m) => m.MasterModule),
  },
  // {
  //   path: 'master',
  //   canActivate: [AuthGuard],
  //   loadChildren: () =>
  //     import('./master/master.module').then((m) => m.MasterModule),
  // },
  {
    path: 'vendor',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./vendor-panel/vendor-panel.module').then((m) => m.VendorPanelModule)
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
